






import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import { openDocumentUrl } from "@/shared/urlHelper";
@Component({
  components: {}
})
export default class DocumentLink extends Vue {
  @Prop({ required: true })
  url: string;

  onClick () {
    openDocumentUrl(this.url);
  }
}
